import { Card, Flex, NumberInput, Text, Title } from '@tremor/react'
import type { InputsState, Labels } from '../types'

interface Props {
    inputs: InputsState
    setInputs: (updates: Partial<InputsState>) => void
    labels: Labels
}

export default function DatabaseStep({ inputs, setInputs, labels }: Props) {
    return (
        <Card className="bg-teal-800 ring-teal-900">
            <Title className="text-lg mb-2 text-white">
                Databases ({labels.dbName})
            </Title>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">Instances</Text>
                <NumberInput
                    value={inputs.rdsInstances}
                    onValueChange={(v) => setInputs({ rdsInstances: v })}
                    min={0}
                    step={1}
                    className="w-full md:w-48"
                />
            </Flex>
            <Flex
                justifyContent="between"
                alignItems="center"
                className="flex-col gap-2 md:flex-row md:gap-0"
            >
                <Text className="text-white w-full md:w-auto">
                    Average utilization (%)
                </Text>
                <NumberInput
                    value={inputs.rdsAvgUtil}
                    onValueChange={(v) => setInputs({ rdsAvgUtil: v })}
                    min={0}
                    max={100}
                    step={1}
                    className="w-full md:w-48"
                />
            </Flex>
        </Card>
    )
}
